import React, { FunctionComponent, useState } from 'react';
import { Button, Grid, Stack, SxProps, Typography } from '@mui/material';

import { ILessonStudentFeedback } from '../../../store/V2/LessonStudentFeedbacksSlice';
import { IUser } from '../../../store/UserSlice';
import { getShortName } from '../../../helper';
import { CustomCardContent } from './helper';
import ViewStudentFeedbackModal from './ViewStudentFeedbackModal';

interface GroupClassStudentFeedbackContentsForTutorProps {
  feedbacks: ILessonStudentFeedback[];
}

const actionButtonStyles: SxProps = {
  padding: { xs: '6px 12px', sm: '12px 24px' },
  borderRadius: '6px',
  fontWeight: 600,
  fontSize: '12px',
};

const GroupClassStudentFeedbackContentsForTutor: FunctionComponent<GroupClassStudentFeedbackContentsForTutorProps> = ({
  feedbacks,
}) => {
  // State
  const [viewFeedbackModalData, setViewFeedbackModalData] = useState<{
    open: boolean;
    feedback?: ILessonStudentFeedback;
  }>({
    open: false,
  });

  return (
    <div>
      <Grid container rowSpacing="20px">
        <Grid item xs={12}>
          <div>
            <Typography variant="h6">Feedbacks</Typography>
          </div>
        </Grid>
        {feedbacks.map((item) => {
          const feedbackStudent = item.student as IUser;
          const name = getShortName(
            feedbackStudent.firstname,
            feedbackStudent.lastname
          );

          return (
            <Grid item xs={12} key={item._id}>
              <CustomCardContent>
                <Stack direction="row" alignItems="center">
                  <Typography flexGrow={1} className="ellipsis-text one-line">
                    Feedback - {name}
                  </Typography>
                  <Button
                    size="small"
                    variant="contained"
                    color="inherit"
                    sx={{ ...actionButtonStyles, padding: undefined }}
                    onClick={() =>
                      setViewFeedbackModalData({ open: true, feedback: item })
                    }
                  >
                    View
                  </Button>
                </Stack>
              </CustomCardContent>
            </Grid>
          );
        })}
      </Grid>
      {viewFeedbackModalData.open && viewFeedbackModalData.feedback ? (
        <ViewStudentFeedbackModal
          open={viewFeedbackModalData.open}
          onClose={() => setViewFeedbackModalData({ open: false })}
          feedback={viewFeedbackModalData.feedback}
        />
      ) : null}
    </div>
  );
};

export default GroupClassStudentFeedbackContentsForTutor;
